import { createContext, useState } from "react";
import {RouterProvider} from "react-router-dom";
import {createTheme, ThemeProvider} from "@mui/material";
import App from "../../App";

const AuthContext = createContext({});
export const theme = createTheme({
    typography: {
        fontFamily: "Poppins , sans-serif",
    },
    palette: {
        primary: {
            main: "#ED1C24",
            green: "#00A500",
            secondary: "#262262",
            footer: '#262262',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: "8px",
                    textTransform: "none",
                },
                contained: {
                    color: "#fff",
                },
            },
        },
        MuiContainer: {
            styleOverrides: {
                root: {
                    width: "90%",
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                h1: {
                    color: "#000000",
                    fontSize: "56px",
                    fontWeight: "700",
                },
                h2: {
                    color: "#262262",
                    fontWeight: "600",
                    fontSize: "48px",
                    lineHeight: 1.2,
                },
                h3: {
                    color: "#102851",
                    fontSize: "30px",
                    fontWeight: "500",
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    background: "#FAFBFE",
                    borderRadius: "8px",
                    color: "#ABB6C7",
                    "& .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                            borderColor: "#F0F0F0",
                        },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    background: "#FAFBFE",
                    borderRadius: "8px",
                    color: "#ED1C24",
                    "& .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                            borderColor: "#F0F0F0",
                        },
                },
            },
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
        },
    },
});

theme.typography.h2 = {
    [theme.breakpoints.down("sm")]: {
        fontSize: "32px",
    },
};

theme.typography.h1 = {
    [theme.breakpoints.down("sm")]: {
        fontSize: "36px",
    },
};

theme.typography.h3 = {
    [theme.breakpoints.down("sm")]: {
        fontSize: "22px",
    },
};
export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({});
    return (
        <AuthContext.Provider value={{ auth, setAuth }}>
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </AuthContext.Provider>

    )
}

export default AuthContext;
